export default __webpack_public_path__ + "static/vision-9c115838decc8f47fd57a912039518e6.jpg";